import { ActionTree } from 'vuex'
import { IBMState } from './bm-state.store'
import { IRootState } from '../root-state.store'
import * as types from './bm-types.store'
import { IBMParameter } from '../../models/bm'
import { ActivityStatus, CrudStatus } from '../../common/enums'
import { IBMMeetingParameter } from '../../models/bm/bm-meeting.parameter';
import {
  BM_ACTION,
  BM_CREATE_BM,
  BM_CREATE_MEETING,
  BM_EDIT_BM,
  BM_EDIT_BM_BY_FIELD, BM_EDIT_MEETING, BM_EDIT_MEETING_BY_FIELD, BM_GET_PLAN_BY_PARAMS,
  BM_SAVE_DOCUMENT
} from "./bm-types.store";
import * as moment from "moment";
import { IDocument } from "../../models/documents/document";

export const actions: ActionTree<IBMState, IRootState> = {
  [types.BM_GET_BMS]: async ({ commit, state }, payload: { param?: IBMParameter, merge?: boolean }) => {
    if (state.bmsSource.activityStatus === ActivityStatus.Loading) return Promise.reject();
    commit(types.BM_GET_BMS_LOADING, ActivityStatus.Loading);
    return await state.service!.getBMs(payload && payload.param ? payload.param : state.bmParameter, true)
      .then(response => {
        commit(types.BM_GET_BMS,
          {
            activityStatus: ActivityStatus.Loaded,
            bms: response.data,
            merge: (payload || {}).merge || false,
            pagination: { limit: response.limit, total: response.total, skip: response.skip }
          })
        return response.data;
      })
      .catch(error => {
        commit(types.BM_GET_BMS_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  },
  [types.BM_GET_BM_MEETINGS]: async ({ commit, state }, payload: { param?: IBMMeetingParameter, merge?: boolean, bmid: string }) => {
    if (state.bmMeetings.activityStatus === ActivityStatus.Loading) return Promise.reject();
    commit(types.BM_GET_BM_MEETINGS_LOADING, ActivityStatus.Loading);
    return await state.service!.getBMMeetings({ bmid: payload.bmid }, payload && payload.param ? payload.param : state.bmMeetingParameter, true)
      .then(response => {
        commit(types.BM_GET_BM_MEETINGS,
          {
            activityStatus: ActivityStatus.Loaded,
            meetings: response.data,
            merge: payload.merge || false,
            pagination: { limit: response.limit, total: response.total, skip: response.skip }
          })
        return response.data;
      })
      .catch(error => {
        commit(types.BM_GET_BM_MEETINGS_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  }
  , [types.BM_GET_BM]: async ({ commit, state }, id: string) => {
    if (state.bmSource.activityStatus === ActivityStatus.Loading) return;
    commit(types.BM_GET_BM_LOADING, ActivityStatus.Loading);
    return await state.service!.getBMById(id)
      .then(response => {
        commit(types.BM_GET_BM, response)
        return response;
      })
      .catch(error => {
        commit(types.BM_GET_BM_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  }
  , [types.BM_GET_MEETING]: async ({ commit, state, getters }, payload: { bmId: string, idm: string }) => {
    return await state.service!.getMeetingById(payload.bmId, payload.idm)
      .then(response => {
        let meeting = { ...response }
        meeting.generalComments.active = false
        meeting.inspections = meeting.inspections.map(x => {
          x.active = false
          return x
        })
        commit(types.BM_GET_MEETING, meeting)
        return meeting
      })
      .catch(error => {
        commit(types.BM_GET_BM_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  }
  , [types.BM_GET_MEETING_PLAN]: async ({ commit, state, getters }, payload: { bmId: string, idm: string }) => {
    return await state.service!.getMeetingPlans(payload.bmId, payload.idm)
      .then(response => {
        commit(types.BM_GET_MEETING_PLAN, response.data)
        return response
      })
      .catch(error => {
        commit(types.BM_GET_BM_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  },
  [types.BM_GET_MARKERS]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string }) => {
    return await state.service!.getPlanMarkers(payload.bmid, payload.idm, payload.idp)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [BM_GET_PLAN_BY_PARAMS]: async ({ commit, state }, payload: { block, apartment }) => {
    let params: any = {
      block: payload.block,
      apartment: payload.apartment,
      attachment_type: 25,
      $skip: 0
    }
    return state.service!.getDocumentAttachments(params)
      .then((res: any) => { return res })
      .catch(error => { return error })
  },
  [types.BM_POST_BM]: async ({ commit, state, getters }): Promise<any> => {
    let params = { ...getters.bmEdited }
    if (!getters.bmEdited.date_start_building || getters.bmEdited.date_start_building === '') { delete params.date_start_building }
    if (!getters.bmEdited.date_end_building || getters.bmEdited.date_end_building === '') { delete params.date_end_building }
    return state.service!.postBM(params)
      .then(response => {
        commit(types.BM_GET_BM, response)
        return Promise.resolve(response)
      })
      .catch(error => {
        commit(types.BM_GET_BM_LOADING, ActivityStatus.LoadFailed)
        return Promise.reject(error)
      })
  },
  [types.BM_POST_PARTICIPANT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string }): Promise<any> => {
    return state.service!.postBMParticipant(payload.bmid, payload.idm, getters.bmParticipantEdited)
      .then(response => {
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        response.ib = []
        newMeeting.participants.push(response)
        commit(types.BM_GET_MEETING, newMeeting)
        return Promise.resolve(response)
      })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_POST_MEETING]: async ({ commit, state, getters }, payload: { bmid: string }): Promise<any> => {
    let params = { ...getters.bmMeetingEdited }
    if (!getters.bmMeetingEdited.sendNextMeeting) { delete params.date_next_meeting }
    delete params.sendNextMeeting
    return state.service!.postMeeting(payload.bmid, params)
      .then(response => {
        commit(types.BM_GET_MEETING, response)
        return Promise.resolve(response)
      })
      .catch(error => {
        commit(types.BM_GET_MEETING_LOADING, ActivityStatus.LoadFailed)
        return Promise.reject(error)
      })
  },
  [types.BM_POST_IB]: async ({ commit, state, getters }, payload: { bmid: string, idm: string }): Promise<any> => {
    let params = { ...getters.bmIBEdited }
    return state.service!.postBMIB(payload.bmid, payload.idm, params)
      .then(response => {
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        newMeeting.inspections.push(response)
        commit(types.BM_GET_MEETING, newMeeting)
        return Promise.resolve(response)
      })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_POST_PLAN]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, plan?: any }): Promise<any> => {
    let params
    if (payload.plan) params = { ...payload.plan }
    else params = { ...getters.bmPlanEdited }
    return state.service!.postBMPlan(payload.bmid, payload.idm, params)
      .then(response => { return Promise.resolve(response) })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_POST_CONTRACTOR]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string }): Promise<any> => {
    let params = { ...getters.bmContractorEdited }
    return state.service!.postBMContractor(payload.bmid, payload.idm, payload.idi, params)
      .then(response => {
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        if (newMeeting.generalComments.id === payload.idi) {
          newMeeting.generalComments.bm_ib_contractor.push(response)
        } else {
          let indexIB = newMeeting.inspections.findIndex(ib => ib.id === payload.idi)
          newMeeting.inspections[indexIB].bm_ib_contractor.push(response)
        }
        commit(types.BM_GET_MEETING, newMeeting)
        return Promise.resolve(response)
      })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_POST_COMMENT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string }): Promise<any> => {
    let params = {
      ...getters.bmCommentEdited
    }
    return state.service!.postBMComment(payload.bmid, payload.idm, payload.idi, params)
      .then(response => { return Promise.resolve(response) })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_POST_COMMENT_MEDIA]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string, idc: string, params: any }): Promise<any> => {
    return state.service!.postBMCommentMedia(payload.bmid, payload.idm, payload.idi, payload.idc, payload.params)
      .then(response => { return Promise.resolve(response) })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_POST_MEDIA]: async ({ commit, state, getters }, payload: any): Promise<any> => {
    return state.service!.postMedia(payload)
      .then(response => { return Promise.resolve(response) })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_POST_MARKER]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string, params }): Promise<any> => {
    return state.service!.postBMMarker(payload.bmid, payload.idm, payload.idp, payload.params)
      .then(response => { return Promise.resolve(response) })
      .catch(error => { return Promise.reject(error) })
  },
  [types.BM_PATCH_BM]: async ({ commit, state, getters }, payload: { bmid: string }) => {
    let params = { ...getters.bmEdited }
    if (!getters.bmEdited.date_start_building || getters.bmEdited.date_start_building === '') { params.date_start_building = null }
    if (!getters.bmEdited.date_end_building || getters.bmEdited.date_end_building === '') { params.date_end_building = null }
    delete params.fk_block
    delete params.fk_apartment
    return await state.service!.patchBM(payload.bmid, params)
      .then(response => {
        commit(types.BM_GET_BM, response)
        return response
      })
      .catch(error => {
        commit(types.BM_GET_BM, ActivityStatus.LoadFailed)
        return error
      })
  },
  [types.BM_PATCH_PARTICIPANT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string, source: any }) => {
    let params = { ...getters.bmParticipantEdited }
    delete params.fk_entity
    delete params.pid
    if (params.presence === payload.source.presence)
      delete params.presence
    if (params.summon_next_meeting === payload.source.summon_next_meeting)
      delete params.summon_next_meeting
    return await state.service!.patchBMParticipant(payload.bmid, payload.idm, payload.idp, params)
      .then(response => {
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        let indexParticipant = newMeeting.participants.findIndex(x => x.id === response.id)
        newMeeting.participants[indexParticipant] = {
          ...newMeeting.participants[indexParticipant],
          ...response
        }
        commit(types.BM_GET_MEETING, newMeeting)
        return response
      })
      .catch(error => { return error })
  },
  [types.BM_PATCH_MEETING]: async ({ commit, state, getters }, payload: { bmid: string, idm: string }) => {
    let params = { ...getters.bmMeetingEdited }
    if (!getters.bmMeetingEdited.sendNextMeeting) { params.date_next_meeting = null }
    delete params.sendNextMeeting
    delete params.lastMeetingId
    let om = getters.bmMeeting.data
    if (om.date_start === params.date_start)
      delete params.date_start
    if (om.date_end === params.date_end)
      delete params.date_end
    if (om.date_next_meeting === params.date_next_meeting)
      delete params.date_next_meeting
    return await state.service!.patchMeeting(payload.bmid, payload.idm, params)
      .then(response => {
        commit(types.BM_GET_MEETING, response)
        return response
      })
      .catch(error => {
        commit(types.BM_GET_MEETING_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  },
  [types.BM_GENERATE_REPORT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, signatures: any[] }) => {
    let params = {
      generate: true,
      signatures: payload.signatures || []
    }
    return state.service!.patchMeeting(payload.bmid, payload.idm, params)
      .then(response => {
        commit(types.BM_GET_MEETING, response)
        return response
      })
      .catch(error => {
        commit(types.BM_GET_MEETING_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  },
  [types.BM_PATCH_IB]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string }) => {
    let params = { ...getters.bmIBEdited }
    return await state.service!.patchBMIB(payload.bmid, payload.idm, payload.idi, params)
  },
  [types.BM_PATCH_PLAN]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string }) => {
    let params = { ...getters.bmPlanEdited }
    return await state.service!.patchBMPlan(payload.bmid, payload.idm, payload.idp, params)
  },
  [types.BM_PATCH_CONTRACTOR]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string, idc: string, source: any }) => {
    let params = { ...getters.bmContractorEdited }
    if (!params.date_start_work)
      params.date_start_work = null
    if (!params.date_end_work)
      params.date_end_work = null
    delete params.fk_entity_contractor
    if (params.date_start_work === payload.source.date_start_work)
      delete params.date_start_work
    if (params.date_end_work === payload.source.date_end_work)
      delete params.date_end_work
    if (params.progress === payload.source.progress)
      delete params.progress
    return await state.service!.patchBMContractor(payload.bmid, payload.idm, payload.idi, payload.idc, params)
      .then(response => {
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        if (newMeeting.generalComments.id === response.fk_bm_inspection_bundle) {
          let indexContractor = newMeeting.generalComments.bm_ib_contractor.findIndex(ct => ct.id === response.id)
          newMeeting.generalComments.bm_ib_contractor[indexContractor] = {
            ...newMeeting.generalComments.bm_ib_contractor[indexContractor],
            date_start_work: response.date_start_work,
            date_end_work: response.date_end_work,
            progress: response.progress
          }
        } else {
          let indexIB = newMeeting.inspections.findIndex(ib => ib.id === response.fk_bm_inspection_bundle)
          let indexContractor = newMeeting.inspections[indexIB].bm_ib_contractor.findIndex(ct => ct.id === response.id)
          newMeeting.inspections[indexIB].bm_ib_contractor[indexContractor] = {
            ...newMeeting.inspections[indexIB].bm_ib_contractor[indexContractor],
            date_start_work: response.date_start_work,
            date_end_work: response.date_end_work,
            progress: response.progress
          }
        }
        commit(types.BM_GET_MEETING, newMeeting)
        return response
      })
      .catch(error => { return error })
  },
  [types.BM_PATCH_COMMENT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string, idc: string, originalComment: any }) => {
    let oc = payload.originalComment
    let ec = getters.bmCommentEdited
    let params: any = {}
    if (!oc.ticket && ec.createTicket) {
      params.createTicket = ec.createTicket
      if (ec.deadline) params.deadline = ec.deadline
    } else if (oc.ticket) {
      if (oc.ticket.deadline !== ec.deadline) params.deadline = ec.deadline
    }
    if (ec.description !== oc.description) params.description = ec.description
    if (ec.subject !== oc.subject) params.subject = ec.subject
    if (Object.keys(params).length === 0 && params.constructor === Object) {
      return oc
    } else {
      return await state.service!.patchBMComment(payload.bmid, payload.idm, payload.idi, payload.idc, params)
        .then(response => { return response })
        .catch(error => { return error })
    }
  },
  [types.BM_PATCH_MARKER]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string, idmk: string }) => {
    let params = { ...getters.bmMarkerEdited }
    return await state.service!.patchBMMarker(payload.bmid, payload.idm, payload.idp, payload.idmk, params)
  },
  [types.BM_DELETE_BM]: async ({ commit, state, getters }, payload: { bmid: string }) => {
    let deletePayload = { deletedAt: moment().format('YYYY-MM-DDTHH:mm:ss') }
    return await state.service!.patchBM(payload.bmid, deletePayload)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [types.BM_ARCHIVE_BM]: async ({ commit, state, getters }, payload: { bmid: string }) => {
    let archivePayload = { is_archived: !state.bmSource.detail.is_archived }
    return await state.service!.patchBM(payload.bmid, archivePayload)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [types.BM_ARCHIVE_MEETING]: async ({ commit, state, getters }, payload: { bmid: string, idm: string }) => {
    let archivePayload = { is_archived: !getters.bmMeeting.data.is_archived }
    return await state.service!.patchMeeting(payload.bmid, payload.idm, archivePayload)
      .then(response => {
        commit(types.BM_GET_MEETING, response)
        return response
      })
      .catch(error => {
        commit(types.BM_GET_MEETING_LOADING, ActivityStatus.LoadFailed)
        return error
      })
  },
  [types.BM_DELETE_MEETING]: async ({ commit, state, getters }, payload: { bmid: string, idm: string }) => {
    let deletePayload = { deletedAt: moment().format('YYYY-MM-DDTHH:mm:ss') }
    return await state.service!.patchMeeting(payload.bmid, payload.idm, deletePayload)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [types.BM_DELETE_PARTICIPANT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string }) => {
    return await state.service!.deleteBMParticipant(payload.bmid, payload.idm, payload.idp)
      .then(response => {
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        let indexParticipant = newMeeting.participants.findIndex(x => x.id.toString() === payload.idp)
        newMeeting.participants.splice(indexParticipant, 1)
        commit(types.BM_GET_MEETING, newMeeting)
        return response
      })
      .catch(error => { return error })
  },
  [types.BM_DELETE_IB]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string }) => {
    return await state.service!.deleteBMIB(payload.bmid, payload.idm, payload.idi)
      .then(response => {
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        let indexIB = newMeeting.inspections.findIndex(x => x.id === payload.idi)
        newMeeting.inspections.splice(indexIB, 1)
        commit(types.BM_GET_MEETING, newMeeting)
        return response
      })
      .catch(error => { return error })
  },
  [types.BM_DELETE_PLAN]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string, force?: boolean }) => {
    /* let deletePayload = {deletedAt: moment().format('YYYY-MM-DDTHH:mm:ss')}
    return await state.service!.patchBMPlan(payload.bmid, payload.idm, payload.idp, deletePayload)
      .then(response => {return response})
      .catch(error => {return error}) */
    return await state.service!.deleteBMPlan(payload.bmid, payload.idm, payload.idp, payload.force)
  },
  [types.BM_DELETE_CONTRACTOR]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string, idc: string }) => {
    return await state.service!.deleteBMContractor(payload.bmid, payload.idm, payload.idi, payload.idc)
      .then(response => {
        let indexIB = getters.bmMeeting.data.inspections.findIndex(ib => ib.id.toString() === payload.idi)
        let indexContractor = getters.bmMeeting.data.inspections[indexIB].bm_ib_contractor.findIndex(ct => ct.id === payload.idc)
        let newMeeting = (JSON.parse(JSON.stringify(getters.bmMeeting.data)))
        newMeeting.inspections[indexIB].bm_ib_contractor.splice(indexContractor, 1)
        commit(types.BM_GET_MEETING, newMeeting)
        return response
      })
      .catch(error => { return error })
  },
  [types.BM_DELETE_COMMENT_MEDIA]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string, idc: string, idf: string }) => {
    return await state.service!.deleteBMCommentMedia(payload.bmid, payload.idm, payload.idi, payload.idc, payload.idf)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [types.BM_DELETE_COMMENT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string, idc: string }) => {
    let deletePayload = { deletedAt: moment().format('YYYY-MM-DDTHH:mm:ss') }
    return await state.service!.patchBMComment(payload.bmid, payload.idm, payload.idi, payload.idc, deletePayload)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [types.BM_DELETE_MARKER]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idp: string, idmk: string }) => {
    return await state.service!.deleteBMMarker(payload.bmid, payload.idm, payload.idp, payload.idmk)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [types.BM_OPEN_CLOSE_COMMENT]: async ({ commit, state, getters }, payload: { bmid: string, idm: string, idi: string, idc: string, cmtState: string }) => {
    let statePayload = { state: payload.cmtState }
    return await state.service!.patchBMComment(payload.bmid, payload.idm, payload.idi, payload.idc, statePayload)
      .then(response => { return response })
      .catch(error => { return error })
  },
  [BM_EDIT_BM]: ({ commit, state }) => {
    const currentBM: any = state.bmSource.detail
    commit(BM_EDIT_BM_BY_FIELD, {
      fk_block: currentBM.fk_block,
      fk_apartment: currentBM.fk_apartment,
      date_start_building: currentBM.date_start_building,
      date_end_building: currentBM.date_end_building
    })
    commit(BM_ACTION, CrudStatus.Update)
  },
  [BM_EDIT_MEETING]: ({ commit, state }) => {
    const currentMeeting: any = state.bmMeeting.data
    commit(BM_EDIT_MEETING_BY_FIELD, {
      date_start: currentMeeting.date_start,
      date_end: currentMeeting.date_end,
      date_next_meeting: currentMeeting.date_next_meeting || moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14) + '00:00',
      lastMeetingId: null,
      sendNextMeeting: !!currentMeeting.date_next_meeting
    })
    commit(BM_ACTION, CrudStatus.Update)
  },
  [BM_CREATE_BM]: ({ commit, state }) => {
    commit(BM_EDIT_BM_BY_FIELD, {
      fk_block: null,
      fk_apartment: null,
      date_start_building: null,
      date_end_building: null
    })
    commit(BM_ACTION, CrudStatus.Create)
  },
  [BM_CREATE_MEETING]: ({ commit, state }) => {
    commit(BM_EDIT_MEETING_BY_FIELD, {
      date_start: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14) + '00:00',
      date_end: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14) + '15:00',
      date_next_meeting: moment().format('YYYY-MM-DDTHH:mm:ss').substring(0, 14) + '00:00',
      lastMeetingId: null,
      sendNextMeeting: false
    })
    commit(BM_ACTION, CrudStatus.Create)
  },
  [BM_SAVE_DOCUMENT]: async ({ commit, getters, state }, payload: IDocument) => {
    return state.service!.saveDocument(payload)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  }
}



// WEBPACK FOOTER //
// ./src/store/building-monitor/bm-actions.store.ts